export enum oktaGroups {
  'tier_basic' = 'tier_basic',
}

export const OktaEmployeesClients = ['Airfinity', 'Employee', 'Test']
